export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title:  '结算单编号',
    field: 'shipmentPayStatementNo',
    minWidth: 1000,
    align: 'left',
    headerAlign: 'left',
    treeNode: true,
    slots: {
      default: 'showItem'
    }
  },
]
